export const CanvasVerticalNavbar = {
  extends: 'Navbar',
  position: 'absolute',
  zIndex: 1,
  top: '50%',
  transform: 'translate3d(0, -50%, 0)',
  left: '--canvas-gutter',
  flow: 'y',
  padding: 'U1 U1',
  round: 'radiusPill',
  gap: 'X',
  theme: 'canvas-card-glass',
  NavbarButtonSet: {
    padding: '0',
    gap: 'Z',
    flow: 'y',
    childProps: {
      padding: 'Y2',
      round: 'radiusPill',
      isActive: (el) => el.call('getFilesSidebar') && el.call('getSidebarContent') === el.section,
      onClick: (ev, el) => {
        const activeContent = el.section
        el.setWindow('explorer', activeContent)
        window.setTimeout(() => {
          el.call('setSidebarContent', activeContent)
        }, 35)
      }
    },
    children: [
      {
        icon: 'content',
        title: (el) => el.call('polyglot', 'editor.panel.artboards'),
        section: 'ARTBOARD_TYPES'
      },
      {
        icon: 'fnOutline',
        title: (el) => el.call('polyglot', 'editor.panel.functions'),
        section: 'FUNCTION_TYPES'
      },
      {
        icon: 'copywritingOutline',
        title: (el) => el.call('polyglot', 'editor.panel.state'),
        section: 'STATE_TYPES'
      },
      {
        icon: 'tree',
        title: (el) => el.call('polyglot', 'editor.ds.title'),
        section: 'DESIGN_SYSTEM_TYPES'
      },
      {
        icon: 'folderOutline',
        title: (el) => el.call('polyglot', 'editor.panel.assets'),
        section: 'ASSETS_TYPES'
      },
      {
        icon: 'fuse',
        title: (el) => el.call('polyglot', 'editor.panel.integrations'),
        section: 'INTEGRATIONS_TYPES'
      },
      {
        icon: 'tutorial outline',
        title: (el) => el.call('polyglot', 'editor.textNavbar.learn'),
        section: 'TUTORIALS'
      }
    ],
    childrenAs: 'props'
  },
  Line: {
    margin: 'Y1 0',
    width: 'fill-available'
  },
  NavbarButtonSet_meta: {
    padding: '0',
    gap: 'Z',
    flow: 'y',
    Expand: {
      title: (el) => el.call('polyglot', 'editor.position.expand'),
      icon: 'arrowAngleRight',
      onClick: (ev, el) => {
        el.toggleWindow('explorer')
      }
    }
  },
  NavbarTooltip: {
    ignoreChildProps: true,
    ignoreChildExtends: true,
    top: '0',
    left: '110%',
    tooltipPosition: 'right',
    shapeDirection: 'left'
  }
}
